import type { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

import { getThemeColor, TMoplaColorsV2 } from '@mopla/mui';

interface IMplContentLoaderProps {
	color?: TMoplaColorsV2;
	size?: number;
}

export const MplContentLoader: FC<IMplContentLoaderProps> = ({
	color = 'solutions.600',
	size = 32,
}) => (
	<Box
		sx={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			flex: 1,
		}}
	>
		<CircularProgress
			size={size}
			sx={(theme) => ({
				color: getThemeColor(color, theme),
			})}
		/>
	</Box>
);
